<template>
  <div>
    <div v-html="protol"></div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        protol:''
      }
    },
    created() {},
    mounted() {
      this.getProtol()
    },
    methods: {
      getProtol(){
        var $this = this
        let param = { }
        var qs = require('qs');
        let url = this.api.userApi.ampapiprivacyAgreement
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          console.log(result)
          if (result.code==200) {
            $this.protol=result.data.privacy_agreement
            // $this.stadium=result.data.stadiums
            // var citytemp=[]
            // for (var i = 0; i < result.data.stadiums.length; i++) {
            //   citytemp.push(result.data.stadiums[i].city)
            // }
            // console.log(citytemp)
            // console.log($this.unique(citytemp))
            // $this.city=$this.unique(citytemp)
          }
        }).catch((error) => {
          console.warn(error)
        })
      }
    },
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;

</style>



// WEBPACK FOOTER //
// src/components/protocol/appprivacy.vue